import { useLang } from '@/i18n/LanguageContext';

function CheckMk() {
  return (
    <span className="mk">
      <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
        <path
          d="M2 7l3.5 3.5L12 4"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export function TwoSides() {
  const { t } = useLang();
  return (
    <section className="section section--alt" data-screen-label="Two sides">
      <div className="container">
        <div className="section-head reveal">
          <span className="eyebrow">{t('sides.eyebrow')}</span>
          <h2 className="h-section">
            {t('sides.h2.line1')}
            <br />
            {t('sides.h2.line2')}
          </h2>
          <p className="lead">{t('sides.lead')}</p>
        </div>

        <div className="sides">
          <div className="side side--reps reveal" data-d="1">
            <div className="tag">{t('sides.reps.tag')}</div>
            <h3>{t('sides.reps.h3')}</h3>
            <ul>
              <li>
                <span className="mk">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                    <path d="M7 3.5V7l2.5 1.5M7 1a6 6 0 1 0 0 12A6 6 0 0 0 7 1Z" stroke="currentColor" strokeWidth="1.3" />
                  </svg>
                </span>
                <span>{t('sides.reps.li1')}</span>
              </li>
              <li>
                <CheckMk />
                <span>{t('sides.reps.li2')}</span>
              </li>
              <li>
                <CheckMk />
                <span>{t('sides.reps.li3')}</span>
              </li>
              <li>
                <CheckMk />
                <span>{t('sides.reps.li4')}</span>
              </li>
            </ul>
          </div>

          <div className="side side--mgr reveal" data-d="2">
            <div className="tag">{t('sides.mgr.tag')}</div>
            <h3>{t('sides.mgr.h3')}</h3>
            <ul>
              <li>
                <span className="mk">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                    <path d="M1 7s2-4 6-4 6 4 6 4-2 4-6 4-6-4-6-4Z" stroke="currentColor" strokeWidth="1.2" />
                    <circle cx="7" cy="7" r="1.6" fill="currentColor" />
                  </svg>
                </span>
                <span>{t('sides.mgr.li1')}</span>
              </li>
              <li>
                <span className="mk">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
                    <path d="M2 9l3-3 2.5 2 4.5-5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <span>{t('sides.mgr.li2')}</span>
              </li>
              <li>
                <CheckMk />
                <span>{t('sides.mgr.li3')}</span>
              </li>
              <li>
                <CheckMk />
                <span>{t('sides.mgr.li4')}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export function Scenarios() {
  const { t } = useLang();
  return (
    <section className="section" data-screen-label="Scenarios">
      <div className="container">
        <div className="section-head reveal">
          <span className="eyebrow">{t('scn.eyebrow')}</span>
          <h2 className="h-section">
            {t('scn.h2.line1')}
            <br />
            {t('scn.h2.line2')}
          </h2>
          <p className="lead">{t('scn.lead')}</p>
        </div>

        <div className="scenarios">
          <article className="scenario reveal" data-d="1">
            <div className="gico">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M3 7l9-4 9 4-9 4-9-4Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M3 12l9 4 9-4M3 17l9 4 9-4" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
              </svg>
            </div>
            <h3>{t('scn.c1.h3')}</h3>
            <p>{t('scn.c1.p')}</p>
          </article>

          <article className="scenario reveal" data-d="2">
            <div className="gico">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M12 3a4 4 0 0 1 4 4c0 2-2 3-2 5h-4c0-2-2-3-2-5a4 4 0 0 1 4-4Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
                <path d="M9.5 18h5M10.5 21h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <h3>{t('scn.c2.h3')}</h3>
            <p>{t('scn.c2.p')}</p>
          </article>

          <article className="scenario reveal" data-d="3">
            <div className="gico">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 12a7 7 0 0 1 12-5M19 12a7 7 0 0 1-12 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M17 3v4h-4M7 21v-4h4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3>{t('scn.c3.h3')}</h3>
            <p>{t('scn.c3.p')}</p>
          </article>
        </div>
      </div>
    </section>
  );
}

const DIMS = [
  { n: '01', wordKey: 'comp.dim1.word', pKey: 'comp.dim1.p' },
  { n: '02', wordKey: 'comp.dim2.word', pKey: 'comp.dim2.p' },
  { n: '03', wordKey: 'comp.dim3.word', pKey: 'comp.dim3.p' },
  { n: '04', wordKey: 'comp.dim4.word', pKey: 'comp.dim4.p' },
];

export function Compounding() {
  const { t } = useLang();
  return (
    <section className="section section--alt" data-screen-label="Compounding">
      <div className="container">
        <div className="compound-head">
          <div className="section-head reveal" style={{ maxWidth: 'none' }}>
            <span className="eyebrow">{t('comp.eyebrow')}</span>
            <h2 className="h-section">
              {t('comp.h2.line1')}
              <br />
              {t('comp.h2.line2')}
              <br />
              {t('comp.h2.line3')}
            </h2>
            <p className="lead">{t('comp.lead')}</p>
          </div>
          <div className="curve-card reveal" data-d="1">
            <svg viewBox="0 0 320 150" style={{ width: '100%', height: 'auto' }} preserveAspectRatio="none">
              <defs>
                <linearGradient id="cg" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0" stopColor="#7c5cf0" stopOpacity="0.18" />
                  <stop offset="1" stopColor="#7c5cf0" stopOpacity="0" />
                </linearGradient>
              </defs>
              <path className="curve-grow" d="M6 132 C90 126, 150 110, 210 74 S290 18, 314 8 L314 144 L6 144 Z" fill="url(#cg)" />
              <path className="curve-grow-line" d="M6 132 C90 126, 150 110, 210 74 S290 18, 314 8" fill="none" stroke="#7c5cf0" strokeWidth="2.5" strokeLinecap="round" />
              <path d="M6 120 L314 110" fill="none" stroke="var(--faint)" strokeWidth="1.5" strokeDasharray="5 5" strokeLinecap="round" />
              <circle className="curve-dot" cx="314" cy="8" r="4" fill="#7c5cf0" />
            </svg>
            <div className="clabels">
              <span>{t('comp.curve.day1')}</span>
              <span style={{ color: 'var(--faint)' }}>{t('comp.curve.decay')}</span>
              <span style={{ color: 'var(--brand-ink)' }}>{t('comp.curve.compound')}</span>
            </div>
          </div>
        </div>

        <div className="dims">
          {DIMS.map((d, i) => (
            <div className="dim reveal" data-d={i + 1} key={d.n}>
              <div className="dword">
                <span className="n">{d.n}</span>
                {t(d.wordKey)}
              </div>
              <p>{t(d.pKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
